'use client';

import { useTranslations } from '@power-core/toolkit';
import type { FunctionComponent } from 'react';

import { AbbTriangleDown } from '@/assets/icons/components/abb-triangle-down';
import { useTheme } from '@/modules/utils/custom-hooks/use-theme';
import { Flexbox } from '@/ui-components/flexbox/flexbox';
import { Paragraph } from '@/ui-components/paragraph/paragraph';

import { SharedDocumentList } from '../shared-documents-list/shared-documents-list';

export const SharedDocumentsRow: FunctionComponent<{
	isOpen?: boolean;
	onToggle?: () => void;
}> = ({ isOpen, onToggle }) => {
	const t = useTranslations();
	const { isDarkTheme } = useTheme();

	return (
		<Flexbox
			direction='col'
			className={`pt-3 ${isOpen ? 'shadow-sm-light shadow-n400_input_stroker bg-n50_hover m-0.5 rounded-card dark:shadow-n500_light_text dark:bg-bg_dark' : ''}`}
		>
			<Flexbox direction='col'>
				<Flexbox justify='between' onClick={onToggle} className='cursor-pointer px-3 pb-3'>
					<Paragraph variant={isOpen ? 'text-base-semibold' : 'text-base'} className='w-5/6'>
						{t('T_SHARED_DOCUMENTS')}
					</Paragraph>

					<AbbTriangleDown
						size={20}
						fill={isDarkTheme ? '#f1f1f1' : '#1f1f1f'}
						className={`transition-transform duration-200 ${isOpen ? 'rotate-0' : '-rotate-90'}`}
					/>
				</Flexbox>
			</Flexbox>
			<SharedDocumentList isOpen={isOpen} />
		</Flexbox>
	);
};
